import { type InnerRefProps, Icon, ProgressBar, Text } from "@mdotm/shadcn/legacy/components";
import { type ImperativeHandleRefProps, Switch } from "@mdotm/shadcn/legacy/react-extensions";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import {
	type FakeAiLoaderActions,
	type FakeAiLoaderStep,
	type UseFakeAiLoaderParams,
	useFakeAiLoader,
} from "$root/components/FakeAiLoader/common";
import { useImperativeHandle } from "react";

export type FakeAiLoaderBaseProps = {
	state: FakeAiLoaderStep;
} & InnerRefProps<HTMLDivElement> &
	UseFakeAiLoaderParams;

export function FakeAiLoaderBase(props: FakeAiLoaderBaseProps): React.JSX.Element {
	return (
		<div ref={props.innerRef} className={`bg-[color:var(--palette-P50)] rounded-sm overflow-hidden min-h-fit`}>
			<div className="w-full pt-2">
				<div className="flex justify-center space-x-2 items-center">
					<Icon icon="calulating" color={themeCSSVars.palette_P400} size={16} className="animate-spin" />
					<Text type="Body/L/Book" as="p" color={themeCSSVars.palette_N700}>
						<Switch
							case={props.state.stepName}
							match={{
								recovering: () => "1/3 - Retrieving data",
								analysing: () => "2/3 - Analysing data",
								preparing: () => "3/3 - Preparing and formatting your response",
							}}
						/>
					</Text>
				</div>

				<div className="min-w-0 w-full mt-2">
					<ProgressBar accentColor={themeCSSVars.palette_P400} className="w-full" value={props.state.progress} />
				</div>
			</div>
		</div>
	);
}

export type FakeAiLoaderProps = ImperativeHandleRefProps<FakeAiLoaderActions> &
	InnerRefProps<HTMLDivElement> &
	UseFakeAiLoaderParams;
function FakeAiLoader(props: FakeAiLoaderProps): React.JSX.Element {
	const { state, ...handles } = useFakeAiLoader(props);
	useImperativeHandle(props.handleRef, () => handles, [handles]);

	return <FakeAiLoaderBase state={state} />;
}

export default FakeAiLoader;
